// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find-race-container {
  width: 100%;
  padding: 40px 20px;
  background-color: #BA1E24;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}
.coming-soon-button{
  width: 100%;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  min-width: 120px;
  text-align: center;
  white-space: nowrap;
  background-color: white;
  color: black;
}
.find-race-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: 0;
  pointer-events: none;
}

.find-race-container h1 {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  font-size: 48px;
  margin-bottom: 40px;
  font-weight: bold;
}

.race-cards-wrapper {
  position: relative;
  z-index: 2;
  /* max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px; */
}

.race-cards-container {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  padding: 20px 0;
}

.race-cards-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: background-color 0.3s;
}

.scroll-btn:hover {
  background-color: white;
}

.scroll-left {
  left: 0;
}

.scroll-right {
  right: 0;
}

.race-card {
  flex: 0 0 300px;
  position: relative;
  overflow: hidden;
  background: #000000;
}

.race-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.race-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
}

.race-info h2 {
  font-size: 32px;
  margin: 0 0 5px 0;
  font-weight: bold;
}

.race-info p {
  margin: 0 0 15px 0;
  font-size: 16px;
}

.button-group {
  display: flex;
  gap: 10px;
  white-space: nowrap; /* Prevent text wrapping */
}

.know-more-btn-race, .register-btn-race {
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  min-width: 120px;
  text-align: center;
  white-space: nowrap;
}

.know-more-btn-race {
  background-color: white;
  color: black;
}

.register-btn-race {
  background-color: #A41E22;
  color: white;
}

.register-btn-race:hover {
  background-color: #8a1a1d;
}

.know-more-btn-race:hover {
  background-color: #f0f0f0;
}

@media (max-width: 768px) {
  .coming-soon-button{
  font-size: 10px;
  }
  .find-race-container {
    padding: 40px 20px;
  }

  .find-race-container h1 {
    font-size: 36px;
  }

  .race-cards-container {
    height: 60%;
    padding: 0;
    padding-left: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .race-card {
    min-width: 55vw;
    max-width: 240px;
    padding-bottom: 15px;
  }

  .scroll-btn {
    display: none;
  }

  .race-cards-wrapper {
    overflow: visible;
    padding-right: 1px;
    padding-left: 1px;
  }

  .race-image {
    height: 320px;
  }

  .race-info {
    padding: 15px 12px;
  }

 /* .button-group {
    display: flex;
    gap: 4px;
    margin-top: 10px;
    padding: 0 6px;
  } */
  
  .know-more-btn-race,
  .register-btn-race {
    /* padding: 4px 16px; */
    font-size: 10px;
    min-width: 0;
    flex: 1 1;
    white-space: nowrap;
    text-align: center;
  }

  .race-info h2 {
    font-size: 24px;
    margin-bottom: 8px;
  }

  .race-info p {
    font-size: 14px;
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/newSeason/findracecard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV;;oBAEkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;EACA,eAAe;EACf;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;CAED;;;;;KAKI;;EAEH;;IAEE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,SAAO;IACP,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":[".find-race-container {\n  width: 100%;\n  padding: 40px 20px;\n  background-color: #BA1E24;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n  overflow: hidden;\n}\n.coming-soon-button{\n  width: 100%;\n  padding: 8px 16px;\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n  min-width: 120px;\n  text-align: center;\n  white-space: nowrap;\n  background-color: white;\n  color: black;\n}\n.find-race-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center;\n  opacity: 0.1;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.find-race-container h1 {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  color: white;\n  font-size: 48px;\n  margin-bottom: 40px;\n  font-weight: bold;\n}\n\n.race-cards-wrapper {\n  position: relative;\n  z-index: 2;\n  /* max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 40px; */\n}\n\n.race-cards-container {\n  display: flex;\n  gap: 20px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  padding: 20px 0;\n}\n\n.race-cards-container::-webkit-scrollbar {\n  display: none; /* Chrome, Safari and Opera */\n}\n\n.scroll-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  transition: background-color 0.3s;\n}\n\n.scroll-btn:hover {\n  background-color: white;\n}\n\n.scroll-left {\n  left: 0;\n}\n\n.scroll-right {\n  right: 0;\n}\n\n.race-card {\n  flex: 0 0 300px;\n  position: relative;\n  overflow: hidden;\n  background: #000000;\n}\n\n.race-image {\n  width: 100%;\n  height: 400px;\n  object-fit: cover;\n}\n\n.race-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 20px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));\n  color: white;\n}\n\n.race-info h2 {\n  font-size: 32px;\n  margin: 0 0 5px 0;\n  font-weight: bold;\n}\n\n.race-info p {\n  margin: 0 0 15px 0;\n  font-size: 16px;\n}\n\n.button-group {\n  display: flex;\n  gap: 10px;\n  white-space: nowrap; /* Prevent text wrapping */\n}\n\n.know-more-btn-race, .register-btn-race {\n  padding: 8px 16px;\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n  min-width: 120px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.know-more-btn-race {\n  background-color: white;\n  color: black;\n}\n\n.register-btn-race {\n  background-color: #A41E22;\n  color: white;\n}\n\n.register-btn-race:hover {\n  background-color: #8a1a1d;\n}\n\n.know-more-btn-race:hover {\n  background-color: #f0f0f0;\n}\n\n@media (max-width: 768px) {\n  .coming-soon-button{\n  font-size: 10px;\n  }\n  .find-race-container {\n    padding: 40px 20px;\n  }\n\n  .find-race-container h1 {\n    font-size: 36px;\n  }\n\n  .race-cards-container {\n    height: 60%;\n    padding: 0;\n    padding-left: 0;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .race-card {\n    min-width: 55vw;\n    max-width: 240px;\n    padding-bottom: 15px;\n  }\n\n  .scroll-btn {\n    display: none;\n  }\n\n  .race-cards-wrapper {\n    overflow: visible;\n    padding-right: 1px;\n    padding-left: 1px;\n  }\n\n  .race-image {\n    height: 320px;\n  }\n\n  .race-info {\n    padding: 15px 12px;\n  }\n\n /* .button-group {\n    display: flex;\n    gap: 4px;\n    margin-top: 10px;\n    padding: 0 6px;\n  } */\n  \n  .know-more-btn-race,\n  .register-btn-race {\n    /* padding: 4px 16px; */\n    font-size: 10px;\n    min-width: 0;\n    flex: 1;\n    white-space: nowrap;\n    text-align: center;\n  }\n\n  .race-info h2 {\n    font-size: 24px;\n    margin-bottom: 8px;\n  }\n\n  .race-info p {\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
